<template>
    <div class="title-box">
        <div class="title">
            {{ text }}
        </div>
        <div class="s-title">
            {{ sTitle }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text:'',
        sTitle: ''
    },
    data() {
        return {

        }
    }
}
</script>


<style scoped lang="scss">
.title-box {
    padding-top: 120px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title {
        text-align: center;
        font-weight: 500;
        font-size: 40px;
        color: #14171F;
    }
    .s-title {
        width: 1000px;
        text-align: center;
        font-size: 18px;
        line-height: 28px;
        color: #646A73;
        font-weight: 400;
        margin: 16px 0 50px;
    }

}
</style>


// WEBPACK FOOTER //
// src/components/title.vue